var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.requisicao)?_c('div',[_c('app-tabela',{attrs:{"itens":_vm.requisicao.emailsEnvios,"campos":_vm.campos,"itensPorPagina":_vm.itensPorPagina,"bordered":false,"small":false}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }